export const getUniqueArrayItemsByProperty = <T>(list: T[], key: keyof T) => {
  const map = new Map();

  for (const obj of list) {
    map.set(obj[key], obj);
  }

  return [...map.values()];
};

export function isElementInViewport(element: HTMLElement, checkElemWidthPosition: boolean = false) {
  const elementRect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  return (
    elementRect.top >= 0 &&
    elementRect.bottom <= windowHeight &&
    (checkElemWidthPosition ? elementRect.left >= 0 : true) &&
    (checkElemWidthPosition ? elementRect.right <= windowWidth : true)
  );
}

export function parseJson<T>(jsonString: string | null | undefined) {
  if (jsonString == null) {
    return null;
  }

  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return null;
  }
}

export function clearObject(target: object) {
  const result = {} as Record<string, any>;

  for (const [key, value] of Object.entries(target)) {
    if (value !== null && value !== undefined && value !== '') {
      result[key] = value;
    }
  }

  return result;
}

export function hasValue(obj: object) {
  return Object.values(obj).filter(value => Array.isArray(value) ? value.length > 0 : Boolean(value)).length;
}

export function isValidNewName({ current, newValue, existed }: { current: string, existed: string[], newValue: string; }) {
  const normalizedCurrent = current.toLowerCase();
  const normalizedNew = newValue.toLowerCase();

  if (normalizedCurrent === normalizedNew) {
    return true;
  }

  const exists = existed.some(
    name => name.toLowerCase() === normalizedNew,
  );

  return !exists;
}
